import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "inspect-cover",
  "use": "inspect-cover-usage",
  "viewBox": "0 0 63.34 77",
  "content": "<symbol viewBox=\"0 0 63.34 77\" id=\"inspect-cover\"><defs><style>#inspect-cover .cls-1{fill:#fff;opacity:0.2;}</style></defs><title>资源 23</title><g id=\"inspect-cover_图层_2\" data-name=\"图层 2\"><g id=\"inspect-cover_图层_1-2\" data-name=\"图层 1\"><path d=\"M63.26,11.16l-3.13,0A44.62,44.62,0,0,1,45.8,8,66.89,66.89,0,0,1,33.53,1.39L31.63,0,29.77,1.39A61.64,61.64,0,0,1,17.5,8,44.81,44.81,0,0,1,3.17,11.12L0,11.16V43.55C0,59.82,20.59,77,31.67,77S63.34,59.82,63.34,43.55ZM45.13,40.8a4.7,4.7,0,0,1-4.25,2.7H36.61v6.32a4.65,4.65,0,0,1-.9,2.75,4.7,4.7,0,0,1-8.94-2v-7h-4.7a4.7,4.7,0,0,1-3.38-8,4.68,4.68,0,0,1,3.89-2.08h4.18V27a4.68,4.68,0,0,1,1.3-3.24,4.68,4.68,0,0,1,8.55,2.63v7H41.3a4.67,4.67,0,0,1,3.83,7.36Z\" /><path class=\"cls-1\" d=\"M27.39,2.86c-.64,0-13.17,9.15-27.11,8.28v32c0,11.22,9.17,25.76,26.39,33C46.71,66.26,64.67,28.52,27.39,2.86Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/inspect-cover.svg
// module id = oTFP
// module chunks = 264